import * as THREE from 'three';

// Shared geometry/materials for player-planted Christmas trees. One mesh
// per active tree but they all reuse the same GPU buffers.
const TRUNK_GEO = new THREE.CylinderGeometry(0.18, 0.22, 1.6, 8);
const FOLIAGE_GEO = new THREE.ConeGeometry(1.0, 2.6, 12);
const STAR_GEO = new THREE.OctahedronGeometry(0.22);
const TRUNK_MAT = new THREE.MeshStandardMaterial({ color: 0x5a3a1b, roughness: 0.9 });
const FOLIAGE_MAT = new THREE.MeshStandardMaterial({
  color: 0x166534,
  emissive: 0x0c3a1a,
  emissiveIntensity: 0.25,
  roughness: 0.7,
});
const STAR_MAT = new THREE.MeshStandardMaterial({
  color: 0xfde047,
  emissive: 0xfacc15,
  emissiveIntensity: 0.9,
});

// A festive Christmas tree planted on the course by another racer's item.
// Stuns anyone who slides into it on the server side; the client just
// renders the visual and pops it when the server stops broadcasting it.
export class PlantedTree {
  constructor(scene, position) {
    this.group = new THREE.Group();
    this.group.position.set(position.x, position.y, position.z);

    const trunk = new THREE.Mesh(TRUNK_GEO, TRUNK_MAT);
    trunk.position.y = 0.8;
    trunk.castShadow = true;
    this.group.add(trunk);

    const foliage = new THREE.Mesh(FOLIAGE_GEO, FOLIAGE_MAT);
    foliage.position.y = 2.7;
    foliage.castShadow = true;
    this.group.add(foliage);

    const star = new THREE.Mesh(STAR_GEO, STAR_MAT);
    star.position.y = 4.15;
    this.group.add(star);
    this._star = star;

    scene.add(this.group);
  }

  update(timeSec) {
    // Slow spin on the star so the tree reads as a powerup-placed object
    // rather than scenery.
    this._star.rotation.y = timeSec * 1.5;
  }

  destroy() {
    this.group.parent?.remove(this.group);
  }
}
